import React from 'react'

export interface TableRowProps {
  children: React.ReactNode
  columns: number
  onClick?: () => void
  className?: string
}

export const TableRow: React.FC<TableRowProps> = ({
  children,
  columns,
  onClick,
  className = ''
}) => {
  const handleClick = () => {
    if (onClick) {
      onClick()
    }
  }

  return (
    <div
      className={`px-8 py-4 text-sm text-gray-900 border-b border-gray-200 last:border-b-0 transition-colors ${
        onClick ? 'hover:bg-gray-50 cursor-pointer' : ''
      } ${className}`}
      style={{ display: 'grid', gridTemplateColumns: `repeat(${columns}, 1fr)` }}
      onClick={handleClick}
    >
      {children}
    </div>
  )
}
